export const useDateConverter = () => {
  const convertDate = (date) => {
    const split = date.split("-");
    return split[2] + "-" + split[1] + "-" + split[0];
  };

  return convertDate;
};
